export default {
  AddTicketMessage: 'Add TicketMessage',
  Attachment: 'Attachment',
  Attachments: 'Attachments',
  Contents: 'Contents',
  Department: 'Department',
  Email: 'Email',
  Priority: 'Priority',
  Messages: 'Messages',
  Mobile: 'Mobile',
  Name: 'Name',
  Respond: 'Respond',
  respondContact: 'response to contact',
  Responder: 'Responder',
  State: 'State',
  Title: 'Title',
  Ticket: 'Ticket',
  User: 'User',
  creationTime: 'Creation time',
  Responder_s: 'Responder (s)',
  areYouSureYouWantToDeleteThisContact:
    'Are you sure you want to delete this contact?',
  contactResponseSuccessfullyRegistered:
    'The callback was successfully registered',
  ticketResponseSuccessfullyRegistered:
    'Ticket response successfully registered',
  tickets: 'Tickets',
  clientType: 'Client Type',
  ticketWasClosedSuccessfuly: 'Ticket was closed successfuly',
  ticketWasOpenedSuccessfuly: 'Ticket was opened successfuly'
}
